import get from 'lodash.get';

import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
// @ts-ignore
import { selectActiveTableCellRowIds } from 'services/selectedTableCells/selectors';
import { FertilizerEventUuid } from 'services/fertilizerEvents/types';

const selectCopyFertilizerEventUuid = createDeepEqualSelector(
    selectActiveTableCellRowIds,
    (uuids: FertilizerEventUuid[]) => get(uuids, 0)
);

const makeSelectCopyFertilizerEventUuid =
    (): typeof selectCopyFertilizerEventUuid => selectCopyFertilizerEventUuid;

export { makeSelectCopyFertilizerEventUuid };
